import axios from 'axios';

/**
 * ACTION TYPES
 */
const GET_OPEN_CART_ITEMS = 'GET_OPEN_CART_ITEMS';
const ADD_CART_ITEM = 'ADD_CART_ITEM';
const UPDATE_CART_ITEM = 'UPDATE_CART_ITEM';
const DELETE_CART_ITEM = 'DELETE_CART_ITEM';

/**
 * INITIAL STATE
 */
const cartItems = [];

/**
 * ACTION CREATORS
 */
const getOpenCartItems = (cartItems) => ({
  type: GET_OPEN_CART_ITEMS,
  cartItems,
});
const addCartItem = (cartItem) => ({ type: ADD_CART_ITEM, cartItem });
const updateCartItem = (updatedCartItem) => ({
  type: UPDATE_CART_ITEM,
  updatedCartItem,
});
const deleteCartItem = (cartItem) => ({
  type: DELETE_CART_ITEM,
  cartItem,
});

/**
 * THUNK CREATORS
 */
// Invalidate in-flight GETs so a slower empty response cannot wipe a newer cart.
let cartFetchId = 0;

export const getOpenCartItemsThunk = () => async (dispatch) => {
  const fetchId = ++cartFetchId;
  try {
    const res = await axios.get('/api/cartItems/');
    if (fetchId !== cartFetchId) return;
    dispatch(getOpenCartItems(res.data));
  } catch (err) {
    console.error(err);
  }
};

export const addToCart = (cartItem) => async (dispatch) => {
  const res = await axios.post('/api/cartItems/', { cartItem });
  cartFetchId += 1;
  dispatch(addCartItem(res.data));
  return res.data;
};

export const updateCart = (cartItem, updatedQuantity) => async (dispatch) => {
  try {
    const res = await axios.put('/api/cartItems/', {
      cartItem,
      updatedQuantity,
    });
    cartFetchId += 1;
    dispatch(updateCartItem(res.data));
  } catch (err) {
    console.error(err);
  }
};

export const deleteFromCart = (cartItem) => async (dispatch) => {
  try {
    if (!cartItem.id) cartItem.id = cartItem.productId;
    await axios.delete(`/api/cartItems/${cartItem.id}`);
    cartFetchId += 1;
    dispatch(deleteCartItem(cartItem));
  } catch (err) {
    console.error(err);
  }
};

/**
 * REDUCER
 */
export default function (state = cartItems, action) {
  const sameItem = (a, b) => {
    if (a.productId != null && b.productId != null) {
      return a.productId === b.productId;
    }
    if (a.id != null && b.id != null) {
      return a.id === b.id;
    }
    return a.name === b.name;
  };

  switch (action.type) {
    case GET_OPEN_CART_ITEMS:
      return action.cartItems;

    case ADD_CART_ITEM: {
      let newState = [...state];
      let found = false;
      for (let i = 0; i < state.length; i++) {
        if (sameItem(state[i], action.cartItem)) {
          found = true;
          newState[i] = action.cartItem;
        }
      }
      if (!found) newState.push(action.cartItem);
      return newState;
    }

    case UPDATE_CART_ITEM: {
      let updatedState = [...state];
      for (let i = 0; i < state.length; i++) {
        if (sameItem(state[i], action.updatedCartItem)) {
          updatedState[i] = action.updatedCartItem;
        }
      }
      return updatedState;
    }

    case DELETE_CART_ITEM: {
      return state.filter((item) => !sameItem(item, action.cartItem));
    }
    default:
      return state;
  }
}
